function SelectTik(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" 
            width={16} height={16} 
            viewBox="0 0 16 16"
            {...props}
        >
            <path 
                fillRule="evenodd"  
                fill="#009b7f"   
                {...props}
                d="M14 0H2a2.006 2.006 0 00-2 2v12a2.006 2.006 0 002 2h12a2.006 2.006 0 002-2V2a2.006 2.006 0 00-2-2zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6z"
            />
        </svg>
    );
};
export default SelectTik;